import { HintBondPrice } from '../../components/hint-bond-price';
import type { ICurrency } from '../models';

export const ASSET_NAME_STOCK = 'STOCK' as const;
export const ASSET_NAME_BOND = 'BOND' as const;
export const ASSET_NAME_CURRENCY = 'CURRENCY' as const;
export const ASSET_NAME_FOND = 'FOND' as const;
export const ASSET_NAME_INDEX = 'INDEX' as const;

// На бэке доходности организованы как типы, а не периоды
export const PROFITABILITY_TYPE_DAY = 'DAY' as const;
export const PROFITABILITY_TYPE_WEEK = 'WEEK' as const;
export const PROFITABILITY_TYPE_MONTH = 'MONTH' as const;
export const PROFITABILITY_TYPE_THREEMONTHS = 'THREEMONTHS' as const;
export const PROFITABILITY_TYPE_YEAR = 'YEAR' as const;
export const PROFITABILITY_TYPE_YTM = 'YTM' as const; // yield to maturity

export const OFFSET_LIMIT = 20;

export const LOCAL = 'ru-RU';

export const CODE_ALL_CURRENCIES = 'ALL';
export const CODE_ALL_ASSET_GROUPS = 'ALL';

export const CURRENCY_ALL_OBJECT: ICurrency = {
    id: 0,
    name: 'Все',
    code: CODE_ALL_CURRENCIES,
    symbol: '',
    priority: 0,
};

export const FIELD_TICKER = 'ticker';
export const FIELD_ISIN = 'ISIN';

export const SORT_ASC = 'asc';
export const SORT_DESC = 'desc';

export const SORT_TYPES = {
    // сортировка по цене
    lastPriceAsc: 'last_price:asc',
    lastPriceDesc: 'last_price:desc',
    // сортировка по доходности за день
    profitabilityPercentDayAsc: 'profitabilityPercent.DAY:asc',
    profitabilityPercentDayDesc: 'profitabilityPercent.DAY:desc',
    // сортировка по доходности за неделю
    profitabilityPercentWeekAsc: 'profitabilityPercent.WEEK:asc',
    profitabilityPercentWeekDesc: 'profitabilityPercent.WEEK:desc',
    // сортировка по доходности за месяц
    profitabilityPercentMonthAsc: 'profitabilityPercent.MONTH:asc',
    profitabilityPercentMonthDesc: 'profitabilityPercent.MONTH:desc',
    // сортировка по доходности за 3 месяца
    profitabilityPercentThreeMonthsAsc: 'profitabilityPercent.THREEMONTHS:asc',
    profitabilityPercentThreeMonthsDesc: 'profitabilityPercent.THREEMONTHS:desc',
    // сортировка по доходности за год
    profitabilityPercentYearAsc: 'profitabilityPercent.YEAR:asc',
    profitabilityPercentYearDesc: 'profitabilityPercent.YEAR:desc',
    // сортировка по доходности к дате погашения. Только для облигаций
    profitabilityPercentYTMAsc: 'profitabilityPercent.YTM:asc',
    profitabilityPercentYTMDesc: 'profitabilityPercent.YTM:desc',
};

// TODO: собрать сюда все нейминги из пакетов и нужно это вынести все в invest-common, т.к. может сюда войдет и Портал еще
/** Объект с именами полей в SSR */
export const SSR_PROMISE_NAMES = {
    // invest-emitents-carousel
    CAROUSEL_BY_LIST: 'CAROUSEL_BY_LIST',
    CAROUSEL_BY_FILTERS: 'CAROUSEL_BY_FILTERS',
    // invest-emitents-ratings
    RATINGS_BY_LIST: 'RATINGS_BY_LIST',
    RATINGS_BY_FILTERS: 'RATINGS_BY_FILTERS',
    // invest-emitents-detail-card
    DETAIL_CARD_DATA_PROVIDER: 'detail-card-data-provider',
    // invest-emitents-dividend
    DIVIDENDS_LIST: 'DIVIDENDS_LIST',
};

export const ERROR_REQUEST_FOR_EMITENTS =
    'An error occurred while requesting data from the Issuer service';
export const ERROR_CAN_NOT_PARSE_TEMPLATE_URL = 'Can not parse url and make GQL-query';
export const ERROR_CAN_NOT_DETERMINE_ASSET_TYPE = 'Can not determine asset type';

const BOND_OFFER_DATE_NAME = 'bondOfferDate' as const;
const COUPON_FACE_VALUE_NAME = 'couponFaceValue' as const;
const COUPONS_NAME = 'coupons' as const;
const BOND_MATURITY_DATE_NAME = 'bondMaturityDate' as const;

const BOND_OFFER_DATE_LABEL = 'Дата оферты';
const COUPON_FACE_VALUE_LABEL = 'Номинал';
const COUPONS_LABEL = 'Дата выплаты купона';
const BOND_MATURITY_DATE_LABEL = 'Дата погашения';

// TODO: вместо EMPTY_VALUE_TEXT надо использовать DEFAULT_EMPTY_SYMBOL из packages/invest/invest-common/src/constants/date.ts:43
export const EMPTY_VALUE_TEXT = '—';

export const TYPE_SPECIFIC_PROPERTIES_BONDS = {
    [BOND_OFFER_DATE_NAME]: {
        key: BOND_OFFER_DATE_NAME,
        label: BOND_OFFER_DATE_LABEL,
        emptyValueText: EMPTY_VALUE_TEXT,
    },
    [COUPON_FACE_VALUE_NAME]: {
        key: COUPON_FACE_VALUE_NAME,
        label: COUPON_FACE_VALUE_LABEL,
        emptyValueText: EMPTY_VALUE_TEXT,
    },
    [COUPONS_NAME]: {
        key: COUPONS_NAME,
        label: COUPONS_LABEL,
        emptyValueText: EMPTY_VALUE_TEXT,
    },
    [BOND_MATURITY_DATE_NAME]: {
        key: BOND_MATURITY_DATE_NAME,
        label: BOND_MATURITY_DATE_LABEL,
        emptyValueText: EMPTY_VALUE_TEXT,
    },
};

export const HINT_PRICE_CATALOG =
    'Данные могут обновляться с задержкой. Посмотреть актуальную цену можно в веб-терминале или приложении Альфа-Инвестиции.';

export const HINT_PRICE_CARD =
    'Дата обновления цены отображается на графике ниже. Данные могут обновляться с задержкой. Посмотреть актуальную цену можно в веб-терминале или приложении Альфа-Инвестиции.';

export const TITLE_LOT = 'Лот';
export const TITLE_LAST_PRICE = 'Цена';
export const TITLE_DYNAMICS = 'Динамика';
export const TITLE_PROFITABILITY = 'Доходность';

export const SORTING_DYNAMICS = 'По динамике';
export const SORTING_PROFITABILITY = 'По доходности';

export const HINT_STOCK_PROFITABILITY =
    'Рыночная доходность за выбранный период. Рассчитывается как разница между стоимостью актива на определённый момент времени и его стоимостью на текущий день';

export const HINT_BOND_PROFITABILITY =
    'Сколько процентов годовых от номинала вы сможете заработать, если будете держать бумагу до даты погашения или оферты. Доходность к погашению учитывает все выплаты по купонам и выплату номинала';

export const HINT_CURRENCY_PROFITABILITY = 'Изменение курса валюты за выбранный период';

export const HINT_INDEX_PROFITABILITY = 'Изменение стоимости индекса за выбранный период';

export const HINT_FOND_PROFITABILITY =
    'Изменение стоимости за выбранный период. Рассчитывается как разница между ценой пая фонда на определённый момент времени и его стоимостью на текущий день';

export const HINT_CURRENCY_PRICE =
    'Информация о биржевых курсах может меняться с задержкой, проверяйте точный курс в приложении Альфа-Инвестиций или в личном кабинете';

export const HINT_LOT =
    'Лот – это минимальное количество активов при покупке или продаже. Один лот может быть равен 1, 10, 1000 или другому числу активов. Размер лота и необходимую сумму для сделки вы увидите при выставлении заявки';

export const HINT_INDEX_PRICE =
    'Данные могут обновляться с задержкой. Посмотреть актуальную цену можно в веб-терминале или приложении Альфа-Инвестиции';

// TODO: 1. нужно подумать как это развести на отдельние сеттинги
// например, сейчас уже ясно, что для облигаций лотов нет
export const CELL_SETTINGS = {
    [ASSET_NAME_STOCK]: {
        lastPrice: {
            title: TITLE_LAST_PRICE,
            hint: { catalog: HINT_PRICE_CATALOG, detailCard: HINT_PRICE_CARD },
        },
        profitabilityPercent: {
            title: TITLE_PROFITABILITY,
            hint: { catalog: HINT_STOCK_PROFITABILITY, detailCard: HINT_STOCK_PROFITABILITY },
        },
        lot: {
            title: TITLE_LOT,
            hint: { catalog: HINT_LOT, detailCard: HINT_LOT },
        },
    },
    [ASSET_NAME_BOND]: {
        lastPrice: {
            title: TITLE_LAST_PRICE,
            hint: { catalog: HintBondPrice, detailCard: HintBondPrice },
        },
        profitabilityPercent: {
            title: TITLE_PROFITABILITY,
            hint: { catalog: HINT_BOND_PROFITABILITY, detailCard: HINT_BOND_PROFITABILITY },
        },
        lot: {
            title: '',
            hint: { catalog: '', detailCard: '' },
        },
    },
    [ASSET_NAME_CURRENCY]: {
        lastPrice: {
            title: TITLE_LAST_PRICE,
            hint: { catalog: HINT_CURRENCY_PRICE, detailCard: HINT_CURRENCY_PRICE },
        },
        profitabilityPercent: {
            title: TITLE_DYNAMICS,
            hint: { catalog: HINT_CURRENCY_PROFITABILITY, detailCard: HINT_CURRENCY_PROFITABILITY },
        },
        lot: {
            title: TITLE_LOT,
            hint: { catalog: HINT_LOT, detailCard: HINT_LOT },
        },
    },
    [ASSET_NAME_FOND]: {
        lastPrice: {
            title: TITLE_LAST_PRICE,
            hint: { catalog: HINT_PRICE_CATALOG, detailCard: HINT_PRICE_CARD },
        },
        profitabilityPercent: {
            title: TITLE_DYNAMICS,
            hint: { catalog: HINT_FOND_PROFITABILITY, detailCard: HINT_FOND_PROFITABILITY },
        },
        lot: {
            title: TITLE_LOT,
            hint: { catalog: HINT_LOT, detailCard: HINT_LOT },
        },
    },
    [ASSET_NAME_INDEX]: {
        lastPrice: {
            title: TITLE_LAST_PRICE,
            hint: { catalog: HINT_INDEX_PRICE, detailCard: HINT_INDEX_PRICE },
        },
        profitabilityPercent: {
            title: TITLE_DYNAMICS,
            hint: { catalog: HINT_INDEX_PROFITABILITY, detailCard: HINT_INDEX_PROFITABILITY },
        },
        lot: {
            title: '',
            hint: { catalog: '', detailCard: '' },
        },
    },
};
